/**
 * ToC script
 */
class Kosmopedia_ToC {
    constructor() {
        if ($('#anchor-menu-list').length && $('article.text-content').length) {
            this.initToC();
        }
    }

    initToC () {
        let headers = this.findHeaders();
        this.generateToC(headers);
    }

    findHeaders () {
        let headers = $('article.text-content').find('h2, h3, h4, h5, h6');
        let output = [];

        headers.each((i, header) => {
            if (!$(header).attr('id')) {
                return;
            }

            output.push({
                label: $(header).text(),
                url: '#' + $(header).attr('id')
            });
        });

        return output;
    }

    generateToC (headers) {
        if (!headers.length) {
            return;
        }

        let toc = $('#anchor-menu-list');

        for (let i = 0; i < headers.length; i++) {
            let newItem = $('<li class="subpages-menu-item"><a></a></li>');
            newItem.find('a').eq(0).attr('href', headers[i].url);
            newItem.find('a').eq(0).text(headers[i].label);
            newItem.appendTo(toc);
        }
    }
}